<template>
  <el-container class="ym-container">
    <el-header height="56px">
      <el-row type="flex" justify="space-between">
        <el-col :span="3" style="min-width: 225px">
          <div class="ym-header-logo">
            <img
              v-if="!isCollapse"
              src="./assets/img/logo.png"
              alt="logo"
              width="140"
              height="28"
            />
            <img
              v-else
              class="logo-mini"
              src="./assets/img/logo-mini.png"
              alt="logo"
              width="28"
              height="28"
            />
            <i class="icon-y-retract ym-btn-collapse" @click="toggleMenu" v-if="!isCollapse"></i>
            <i class="icon-y-spread ym-btn-collapse" @click="toggleMenu" v-else></i>
          </div>
        </el-col>
        <el-col :span="9" style="min-width: 310px;" :class="{ collapse: isCollapse }">
          <div class="line-bl ym-header-channel" v-if="this.isAff()">
            <i class="icon-y-qudao icon-qudao mr-2"></i>
            <label class="ym-label mr-4">Channel</label>
            <el-select
              v-model="current_aid"
              @change="switchAid"
              placeholder="Please Select"
              class="channel-select"
            >
              <el-option
                v-for="item in channel_list"
                :key="item.id"
                :label="item.id == 0 ? item.name : item.id + ':' + item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="12" style="text-align: right; min-width: 200px">
          <!-- <div class="line-bl mr-6 invite" @click="routerToInvite" v-if="customer_type != 1">
            <i class="icon-y-Invite"></i>
            <span>Invite</span>
          </div>
          <div class="line-bl mr-6 invite" v-if="customer_type != 1">
            <i class="icon-y-Balance"></i>
            <span>
              <span>Bonus:&nbsp;</span>
              <span class="total-bonus">{{ total_bonus ? '$' + total_bonus : '$0' }}</span>
            </span>
          </div> -->
          <div class="line-bl mr-6 ym-header-support" @click="routeToSupport" v-if="this.isAff()">
            <i class="icon-y-bangzhu icon-support"></i>
            <span>FAQ</span>
          </div>
          <div class="ym-header-user line-bl">
            <el-dropdown :hide-on-click="false">
              <span class="el-dropdown-link">
                <img
                  class="avatar"
                  alt="avatar"
                  src="./assets/img/avatar1.jpg"
                  width="30"
                  height="30"
                />
              </span>
              <el-dropdown-menu class="user-dropdown" slot="dropdown">
                <div class="logout">
                  <div class="account mr-2">{{ settings.user.un }}</div>
                  <div class="logout-btn" @click="handleCommand">
                    <i class="icon-y-ym_exit" @click="handleCommand"></i>
                    <span class="ml-2">Sign out</span>
                  </div>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-col>
      </el-row>
    </el-header>

    <el-container class="ym-main">
      <el-aside>
        <el-menu
          unique-opened
          router
          :collapse="isCollapse"
          mode="vertical"
          class="ym-menu"
          :default-active="active_menu"
        >
          <div v-for="(item, index) in $store.getters.menus2" :key="index">
            <el-submenu
              :index="index + ''"
              v-if="!item.u && item.ul.length > 0"
              :key="index"
              :class="customer_type != 1 ? item.t + '_sub' : ''"
            >
              <template slot="title">
                <i :class="`icon-y-${item.i}`"></i>
                <span slot="title" class="ym-sub-text">{{ item.t }}</span>
              </template>
              <el-menu-item
                class="ym-submenu"
                v-for="u in item.ul"
                :index="u.u"
                :key="u.t"
                :class="customer_type != 1 ? item.t : ''"
              >
                {{ u.t }}
              </el-menu-item>
            </el-submenu>
            <el-menu-item v-if="item.u" :index="item.u" :key="item.t">
              <i :class="`icon-y-${item.i}`"></i>
              <span slot="title">{{ item.t }}</span>
            </el-menu-item>
          </div>
        </el-menu>
      </el-aside>

      <el-main>
        <user-status :status.sync="user_status"></user-status>
        <h1 class="ym-title mr-4">{{ this.$router.history.current.meta.title }}</h1>
        <span class="ym-sub-title" v-if="this.$router.history.current.meta.subTitle">
          {{ this.$router.history.current.meta.subTitle }}
        </span>
        <router-view ref="child"></router-view>
      </el-main>

      <tip :show="tip_show"></tip>

      <sdk-terms :show="sdkTermsVisible" :aff_id="aff_id"></sdk-terms>

      <el-dialog
        :visible.sync="dialogVisible"
        width="940px"
        title="Special Promotion"
        v-if="customer_type != 1"
      >
        <el-carousel trigger="click" height="580px">
          <el-carousel-item>
            <img
              class="pointer"
              width="900px"
              height="580px"
              src="@/assets/img/cpl-sml-pc.jpg"
              alt="CPL Smartlink"
            />
          </el-carousel-item>
        </el-carousel>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userStatus from './components/user-status.vue'
import Tip from './components/tip.vue'
import sdkTerms from './components/sdkTerms.vue'

export default {
  components: {
    Tip,
    userStatus,
    sdkTerms,
  },
  data() {
    return {
      isCollapse: false,
      user_status: 1,
      current_aid: '',
      dialogVisible: false,
      sdkTermsVisible: false,
      total_bonus: 0,
      aff_id: 0,
    }
  },
  computed: {
    ...mapGetters(['settings', 'tip_show', 'channel_list', 'aid', 'active_menu']),
  },
  created() {
    this.customer_type = this.settings.user ? this.settings.user.customer_type : -1
    if (this.isAff()) {
      // 恢复原状
      this.getBalance()
    }
    this.isAdBlock().then(v => {
      if (v) {
        this.notifyOpen(
          'Error',
          'We noticed that you may have an Ad Blocker turned on and some errors may occur, we suggest you to turn it off.',
          'error'
        )
      }
    })
    if (document.documentElement.clientWidth < 1120) {
      this.isCollapse = true
    }
    this.$store.dispatch('getPerm').then(() => {
      let status = this.settings.user.status
      this.user_status = status
      this.aff_id = this.settings.user.id
      if (status === 3) {
        this.updateInfo('', true)
      }
      if (this.isAff()) {
        this.$store.dispatch('getChannelList').then(() => {
          this.current_aid = this.aid
        })
      }
      if (this.isSDKAff() && !this.settings.user.sdk_agreement_conformed) {
        this.sdkTermsVisible = true
      }
    })

    let _this = this
    window.addEventListener('resize', function() {
      if (document.documentElement.clientWidth < 1120) {
        _this.isCollapse = true
      }
    })
  },
  watch: {
    aid: {
      handler() {
        this.$store.dispatch('getPerm', 1).then(() => {})
      },
    },
  },
  methods: {
    handleCommand() {
      if (this.isAder()) {
        this.aderLogout()
      } else {
        // aff
        this.Logout()
      }
    },
    toggleMenu() {
      this.isCollapse = !this.isCollapse
    },
    switchAid() {
      this.$store.commit('AID', this.current_aid)
      for (let v of this.channel_list) {
        if (this.current_aid === v.id) {
          this.$store.commit('CHANNEL', v)
          // this.$store.dispatch('getPerm',1).then(() => {})
        }
      }
    },
    routeToSupport() {
      this.$router.push({ path: '/support' })
    },
    routeToAg() {
      window.open('https://account.youcloud.com/enter?type=en_appgrowing&is_en=1', '_blank')
    },
    routeToPromotion() {
      this.dialogVisible = false
      this.$router.push({ path: '/special' })
    },
    routerToInvite() {
      this.$router.push({ path: '/my-account?tab=2' })
    },
    getBalance() {
      this.$http.get('/api/aff/balance/').then(data => {
        this.total_bonus = data.total_bonus
      })
    },
  },
}
</script>

<style lang="scss">
.center {
  text-align: center;
}

.ym-container.el-container {
  height: 100%;
  background-color: #f6f8fb;
  .collapse {
    margin-left: -100px;
    transition: all 0.1s;
  }
  & > .el-header {
    padding: 10px 20px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px 0px rgba(36, 117, 164, 0.08);
    .avatar {
      border-radius: 50%;
      border: 1px solid #e7eaef;
    }
    .line-bl {
      display: inline-block;
    }
    .ym-header-channel {
      text-align: left;
      i {
        color: #d0d3d9;
      }
      .ym-label {
        color: #9b9ea3;
      }
    }
    .invite {
      font-size: 14px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      cursor: pointer;
      color: #76787d;
      vertical-align: super;
      i {
        color: #d0d3d9;
        font-size: 20px;
        margin-right: 8px;
      }
      .total-bonus {
        color: #0080cc;
        font-weight: 600;
      }
    }
    .ym-header-support {
      font-size: 14px;
      width: 88px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      cursor: pointer;
      vertical-align: super;
      i {
        color: #d0d3d9;
        font-size: 20px;
        margin-right: 8px;
      }
      span {
        color: #6b6d71;
      }
    }
    .ym-header-user {
      text-align: right;
      margin-right: 16px;
      .el-dropdown-link {
        display: flex;
        align-items: center;
        cursor: pointer;
        margin-bottom: 14px;
        color: #9b9ea3;
      }
    }
    .ym-header-logo {
      text-align: left;
      .logo-mini {
        margin-left: -4px;
      }
    }
    .ym-btn-collapse {
      margin-left: 18px;
      font-size: 22px;
      cursor: pointer;
      color: #d0d3d9;
    }
  }
  .ym-main {
    min-height: 100%;
    .el-aside {
      width: auto !important;
      margin-top: 2px;
      box-shadow: 4px 0px 8px 0px rgba(36, 117, 164, 0.08);
      z-index: 100;
      .el-submenu.SmartLink_sub::after {
        content: '';
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #ff9933;
        position: absolute;
        top: 60px;
        left: 120px;
      }
      li.el-menu-item.ym-submenu.Offers:nth-of-type(2)::after {
        content: 'New';
        width: 54px;
        height: 16px;
        background: rgba(255, 153, 51, 0.1);
        border-radius: 4px 4px 4px 0px;
        border: 1px solid rgba(255, 153, 51, 1);
        color: #ff9933;
        position: relative;
        top: -8px;
        left: -2px;
        font-size: 12px;
        padding: 2px;
      }
    }
    .el-card.is-always-shadow,
    .el-card.is-hover-shadow:focus,
    .el-card.is-hover-shadow:hover {
      box-shadow: 0 2px 12px 0px rgba(36, 117, 164, 0.08);
    }
    .el-menu {
      color: #c7cbd2;
      height: 100%;
      .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 192px;
      }
    }
    .ym-submenu.el-menu-item.is-active {
      padding-left: 36px !important;
    }
    .el-icon-menu {
      margin-left: 16px;
    }
    .ym-menu.el-menu--collapse {
      .ym-sub-text,
      .el-submenu__title .el-submenu__icon-arrow {
        display: none;
      }
      .is-active .el-tooltip {
        padding: 0 16px !important;
      }
    }
    .ym-menu:not(.el-menu--collapse) {
      width: 200px;
      min-height: 400px;
    }
  }
  .ym-title {
    display: inline-block;
    margin-bottom: 18px;
    font-size: 20px;
    font-weight: 400;
    color: rgba(155, 158, 163, 1);
  }
  .ym-sub-title {
    line-height: 22px;
    font-size: 14px;
    color: #9b9ea3;
  }
}

.user-dropdown {
  background: #fff;
  .logout {
    .account {
      font-size: 14px;
      font-family: PingFang-SC-Regular;
      font-weight: 400;
      color: #37383a;
      padding: 14px 24px;
    }
    .logout-btn {
      background: #ecf6fb;
      color: #0080cc;
      cursor: pointer;
      height: 40px;
      line-height: 40px;
      padding-bottom: 8px;
      .icon-y-ym_exit {
        font-size: 24px;
        margin-left: 24px;
        vertical-align: middle;
      }
      span {
        vertical-align: middle;
      }
    }
  }
}
</style>
